import Cookies from 'js-cookie';

function LogOut() {
  // Remove token and redirect to sign-in
  Cookies.remove('token');
  window.location.href = '/sign-in';
}

export default LogOut;